<template>
  <widget
    :color="color"
    icon="fa fa-phone-alt"
    :title="`${direction === 'inbound' ? 'Inbound' : 'Outbound'} calls today`"
    :value="value"
  />
</template>

<script>
import apiRealtime from '@/apis/realtime'

import Widget from '@/components/widget/widget8'

export default {
  components: {
    Widget
  },
  props: {
    refresh: Boolean,
    direction: String
  },
  data() {
    return {
      color:
        this.direction === 'outbound'
          ? this.$getVoiceOutboundColor[0]
          : this.$getVoiceColor[0],
      value: 0
    }
  },
  watch: {
    refresh: {
      immediate: true,
      handler(val) {
        if (val) this.getVoiceSession()
      }
    }
  },
  methods: {
    async getVoiceSession() {
      try {
        const data = await apiRealtime.getVoiceSession({
          direction: this.direction
        })
        this.value = data.total

        this.$emit('reset', 'voiceSession')
      } catch (error) {}
    }
  }
}
</script>
